import { Component, OnInit } from '@angular/core';
import jsonData  from '../../assets/data/sismos.json';

@Component({
  selector: 'app-mapa',
  templateUrl: './mapa.component.html',
  styleUrls: ['./mapa.component.scss']
})
export class MapaComponent implements OnInit {
  title: string = 'Mapa del Perú - Historico de sismos';
  lat: number = -9.189967;
  lng: number = -75.015152;
  zoom: number = 5.5;
  //jsonData: any = data;
  markers: marker[] = [];
  circles: circle[] = [];
  cadenas:string[] = ['','','','','2019'];
  anio:string="";
  meses:string[]=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
  iconUrl:string = "../../assets/img/transparente.png";
  //
  constructor() { 
    //console.log(jsonData);
  }

  ngOnInit() {
    let indice:number = 0;
    let contador:number = 1000;
    console.log(jsonData[0]);    

    setInterval(() => {
      if(this.circles.length>5){
        //this.circles.shift();
      }
      if(this.markers.length>1){
        this.markers.shift();
      }
      //para que se anime
      let eliminar=false;
      this.circles.forEach(function(circle){
        circle.radius+=330;
        if(circle.radius>=30000*(circle.magnitud*2)){
          eliminar=true;
        }
      });
      if(eliminar) this.circles.shift();

      //cada vez que pasa 150 veces
      if (contador>600){
        //seteo el año
        this.anio=jsonData[indice].f.substr(0,4);
        let mes=parseInt(jsonData[indice].f.substr(5,2))-1;
        let dia=parseInt(jsonData[indice].f.substr(8,2));
        let hora=jsonData[indice].h.substr(0,5);

        this.markers.push(
          {
            lat: +jsonData[indice].l,
            lng: +jsonData[indice].g,
            label: dia + " de " + this.meses[mes] + " a las " + hora + " horas",
            draggable: false
          }
        );
        this.circles.push(
          {
            lat: +jsonData[indice].l,
            lng: +jsonData[indice].g,
            magnitud: +jsonData[indice].m,
            radius: 10,
            fillColor : 'red'
          }
        );
        /*if(this.anio!=this.cadenas[4]){
          this.cadenas.push(this.anio);
          this.cadenas.shift();
        }*/
        //
        //this.cadenas.push(dia + " de " + this.meses[mes] + " a las " + hora + " horas");
        //this.cadenas.shift();
        //this.meses.push(mes);
        indice++;
        contador=0;
      }//end if
      contador++;
    }, 0);

  }

}

interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
}

interface circle {
	lat: number;
	lng: number;
  radius: number;
  magnitud: number;
  fillColor?: string;
}